const createArray = (len: number, start: number) => {
  const res = [];

  for (let i = start; i < start + len; i++) {
    res.push(i);
  }

  return res;
};

export default createArray;
